import { render, staticRenderFns } from "./AccommodationCommissionList.vue?vue&type=template&id=8d7b02ca&"
import script from "./AccommodationCommissionList.vue?vue&type=script&lang=ts&"
export * from "./AccommodationCommissionList.vue?vue&type=script&lang=ts&"
import style0 from "./AccommodationCommissionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports